export default __webpack_public_path__ + "static/media/SDG_BLACK_logo.cff21889.png";